import axios from 'axios';
import BFFProxy from './bffProxy';
import axiosWithPayloadInterceptor from '../interceptor/axiosWithPayloadInterceptor';
import {
  URLS,
  HTTP_METHODS,
  HTTP_STATUS,
} from '../helpers/constants';
import { COST_IMPACT_TERM_FILE_UPLOAD_ERROR } from '../helpers/messageConstant';

/**
 * Fetch data from APIs related to cost impact earned income term
 * @author sban3308
 */

class CostImpactTermsProxy {
  static async fetchEiTermDetails(data) {
    const url = `${URLS.COST_IMPACT_TERM_DETAILS_FETCH}`;
    const config = {
      url,
      method: HTTP_METHODS.POST,
      data
    };
    const response = await axios(config);
    return response.data;
  }

  static async importCostImpactTermFile(params) {
    const { file, requestType } = params;
    try {
      const signedUrlResponse = await BFFProxy.getSignedUrlToUpload(requestType, file.name);
      const s3UploadResponse = await BFFProxy.uploadWithSignedUrl(signedUrlResponse.data.url, file, file.type);
      if (s3UploadResponse.status === HTTP_STATUS.OK) {
        const data = {
          termType: requestType,
          fileName: encodeURIComponent(signedUrlResponse.data.fileName),
          actualFileName: file.name
        };
        const config = {
          url: `${URLS.COST_IMPACT_TERM_FILE_IMPORT_URL}`,
          method: HTTP_METHODS.POST,
          data
        };
        const response = await axiosWithPayloadInterceptor(config);
        return response.data;
      }
      return Promise.reject(new Error(COST_IMPACT_TERM_FILE_UPLOAD_ERROR));
    } catch (e) {
      return Promise.reject(new Error(e.message));
    }
  }
}
export default CostImpactTermsProxy;
